import { AxiosInstance } from 'axios'
import { AppError } from 'src/error/AppError'
import { RegisterUserCmd } from 'src/api/defs/RegisterUserCmd.type'
import { RegistrationResponse } from 'src/api/defs/RegistrationResponse.type'
import { trimStringsDeep } from 'src/utils/trimStringsDeep'

export const DEVICE_ID_STORAGE_KEY = 'deviceId'
export const DEVICE_TOKEN_STORAGE_KEY = 'deviceToken'

export type LoginRequest = {
    username: string
    password: string
    deviceId?: string
    rememberMe: boolean
}

export type LoginResponse = {
    deviceToken: string | null
    token: string
}

export type DeviceLoginRequest = {
    deviceId: string
    deviceToken: string
}

export type RevokedDeviceToken = DeviceLoginRequest

export type ResetPasswordRequest = {
    email: string
    callbackUrl: string
}

export type ResetPasswordChangeRequest = {
    newPassword: string
    token: string
}

export const isInvalidCredentials = (err: AppError): boolean =>
    err.code === 'invalid-credentials'

export class AuthApi {
    constructor(private http: AxiosInstance) {}

    logIn = (req: LoginRequest): Promise<LoginResponse> =>
        this.http
            .post('/auth/custom/login', {
                username: req.username,
                password: req.password,
                rememberMe: req.rememberMe,
                deviceId: req.deviceId,
                domain: 'CLIENT'
            })
            .then((d: any) => d.data as LoginResponse)

    deviceLogIn = (req: DeviceLoginRequest): Promise<string> =>
        this.http
            .post('/auth/custom/device-login', {
                deviceId: req.deviceId,
                deviceToken: req.deviceToken,
                domain: 'CLIENT'
            })
            .then((d: any) => d.data.token as string)

    revokeDeviceToken = (req: RevokedDeviceToken): Promise<void> =>
        this.http
            .post('/auth/custom/revoke-device-token', {
                deviceId: req.deviceId,
                deviceToken: req.deviceToken
            })
            .then((d: any) => d.data)

    register = (req: RegisterUserCmd): Promise<RegistrationResponse> =>
        this.http
            .post('/api/user/register', trimStringsDeep(req))
            .then(r => r.data)

    passwordResetRequest = (req: ResetPasswordRequest): Promise<void> =>
        this.http.post('/auth/password/request-reset', req)

    passwordResetChange = (req: ResetPasswordChangeRequest): Promise<void> =>
        this.http.post('/auth/password/change', req)
}
